
// jQuery wrapper
($ => {
    $.fn.Katalogkalender = function (parameters: Bookhus.IKatalogkalenderParameters) {
        return this.each(function () {
            var katalogkalender = new Bookhus.Katalogkalender($(this), parameters);
        });
    };
})(jQuery);


module Bookhus {

    export interface IKatalogkalenderParameters {
        currentCulture: string;
        currentUserId: number;
        minBookingBorder: number;
        mediumBookingBorder: number;
        reservationRestrictions: boolean;
        separateTime: number;
        showDaysBeforeTodayAsBooked: boolean;
        showDaysAfterTodayAsBooked: number;
    }
    
    export class Katalogkalender {
        private container: JQuery;
        private viewport: JQuery;
        private pane: JQuery;
        private houseId: number;
        private startDate: Date;
        private latestDateDrawn: Date;
        private loaderIconWidth: number;
        private monthsDrawn = 0;
        private localizedValues: LocalizedValues;
        private dayStatusService: CalendarDaydataService;
        private parameters: IKatalogkalenderParameters;
        private scrollTimer;
        private bubbleXpos = 0;
        private domain: string;

        constructor(container: JQuery, parameters: IKatalogkalenderParameters) {
            this.container = container;
            this.parameters = parameters;
            if (this.parameters === undefined) {
                this.parameters = this.getDefaultparameters();
            }

            this.domain = this.container.attr("data-domain");
            if (this.domain === undefined) {
                this.domain = "";
            }
            if (this.domain.length > 0) {
                this.domain = "https://" + this.domain;
            }

            this.localizedValues = new LocalizedValues(this.parameters.currentCulture);
            this.dayStatusService = new CalendarDaydataService(this.parameters.minBookingBorder, this.parameters.mediumBookingBorder, this.parameters.currentUserId, false, this.parameters.separateTime);
            this.getHouseId();
            if ($('#startDate' + this.houseId).length && $('#startDate' + this.houseId).val().length > 0) {
                this.startDate = $.datepicker.parseDate(this.localizedValues.datePattern, $('#startDate' + this.houseId).val());    
            } else {
                this.getStartDate();
            }
            this.drawContainer();
            this.addMonth(true);
            //console.log("constructor");
        }

        private getDefaultparameters(): IKatalogkalenderParameters {
            var parameters: IKatalogkalenderParameters = {
                currentCulture: "da",
                currentUserId: 0,
                minBookingBorder: 5,
                mediumBookingBorder: 10,
                reservationRestrictions: true,
                separateTime: 12,
                showDaysBeforeTodayAsBooked: false,
                showDaysAfterTodayAsBooked: 0
            };
            return parameters;
        }

        private getHouseId(): void {
            this.houseId = +this.container.attr("data-house-id");
        }

        private getStartDate(): void {
            var date = $.datepicker.parseDate(this.localizedValues.datePattern, this.findInputField().val());
            if (date < new Date(2000, 1, 1)) {
                date = new Date(Date.now());
            }
            this.startDate = date;
        }

        private findInputField(): JQuery {
            var inputField = this.container.find("#startdate" + this.houseId);
            if (inputField === undefined || inputField === null) {
                throw new Error("Datofeltet findes ikke");
            }
            return inputField;
        }

        private drawContainer(): void {
            this.container.append(`
                <div class="scroll-left"><span class="fa fa-chevron-left"></span></div>
                <div class="scroll-right"><span class="fa fa-chevron-right"></span></div>
                <div class="viewport"><div class="pane"><div class="loading"></div></div></div>
            `);
            this.viewport = this.container.find(".viewport");
            this.pane = this.container.find(".pane");
            this.loaderIconWidth = this.pane.find(".loading").width();
            this.container.find(".scroll-left").on("mousedown touchstart",(e) => {
                e.preventDefault();
                this.scrollLeft();
            }).on("mouseup mouseleave touchend",(e) => {
                e.preventDefault();
                this.scrollStop();
            });
            this.container.find(".scroll-right").on("mousedown touchstart",(e) => {
                e.preventDefault();
                this.scrollRight();
            }).on("mouseup mouseleave touchend",(e) => {
                e.preventDefault();
                this.scrollStop();
            });
        }

        private scrollLeft(): void {
            this.scrollTimer = setInterval(() => {
                var newPos = this.pane.position().left + 5;
                if (newPos >= 0) {
                    newPos = 0;
                    this.scrollStop();
                }
                this.pane.css("left", newPos + "px");
            }, 10);
        }

        private scrollRight(): void {
            this.scrollTimer = setInterval(() => {
                var newPos = this.pane.position().left - 5;
                var maxScroll = this.viewport.width() - this.pane.width();
                if (newPos <= maxScroll + this.loaderIconWidth) {
                    newPos = maxScroll;
                    this.scrollRightPause();
                    this.addMonth(false);
                }
                this.pane.css("left", newPos + "px");
            }, 10);
        }

        private scrollStop(): void {
            clearInterval(this.scrollTimer);
        }

        private scrollRightPause(): void {
            clearInterval(this.scrollTimer);
            this.scrollTimer = setInterval(() => {
                var newPos = this.pane.position().left - 5;
                var maxScroll = this.viewport.width() - this.pane.width();
                if (newPos > maxScroll) {
                    clearInterval(this.scrollTimer);
                    this.scrollRight();
                }
            }, 50);
        }

        private addMonth(isFirstLoad: boolean): void {
            var self = this;

            if (this.latestDateDrawn === undefined || this.latestDateDrawn === null) {
                this.latestDateDrawn = (new Date(this.startDate.getTime())).addDays(-1);
            }

            var monthToLoad = 1;
            if (isFirstLoad) {
                monthToLoad = 3;
            }

            var currentStartDate = (new Date(this.latestDateDrawn.getTime())).addDays(1);
            var currentEndDate = (new Date(currentStartDate.getFullYear(), currentStartDate.getMonth() + monthToLoad, 1)).addDays(-1);

            var difference = new Date().getTime() - currentStartDate.getTime();
            var years = Math.floor(difference / (1000 * 60 * 60 * 24 * 365));
            if (years >= 1) {
                self.pane.find(".loading").hide();
                return;
            }

            
            var xhr = this.dayStatusService.loadDataAjax(this.houseId, currentStartDate, currentEndDate, this.domain);
            xhr.always(function (jqxhr, textStatus, error) {

                self.drawMonth(currentStartDate);

                //var closedIndicator = self.pane.find(".closed");
                //if (self.latestDateDrawn < self.dayStatusService.houseOpenUntill) {
                //    if(closedIndicator.length > 0) {
                //        closedIndicator.remove();
                //        self.pane.find(".loading").show();
                //    }
                //    if (currentEndDate > self.dayStatusService.houseOpenUntill) {
                //        currentEndDate = self.dayStatusService.houseOpenUntill;
                //    }
                //    self.drawMonth(currentStartDate);
                //} else {
                //    if (closedIndicator.length === 0) {
                //        self.pane.find(".loading").before(`<div class="month-name closed">Lukket</div>`);
                //        self.pane.find(".loading").hide();
                //    }
                //}
            });
        }

        private daysInMonth(date: Date): number {
            var d = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return d.getDate();
        }

        private drawMonth(currentStartDate: Date): void {
            var self = this;
            var insertPosition = this.pane.find(".loading");
            var monthHeader = this.localizedValues.monthNames[currentStartDate.getMonth()].substr(0, 3) + ". '" + currentStartDate.getFullYear().toString().substr(2, 2);
            //insertPosition.before(`<div class="month-name">${monthHeader}</div>`);
            var indhold = `<div class="month-name">${monthHeader}</div>`;

            var weeks = "";
            var weekCount = 1;
            var firstDateInWeek = currentStartDate.getDate();
            var days = "";
            var colors = "";
            var periodDescription = "";

            var daysInMonth = this.daysInMonth(currentStartDate);
            var enddateOfThisMonth = new Date(currentStartDate.getFullYear(), currentStartDate.getMonth(), daysInMonth);

            var today = new Date().getDateWithoutTime().addDays(self.parameters.showDaysAfterTodayAsBooked);

            var channelPeriods = [];
            if (!!this.domain) {
                var enddate = new Date(currentStartDate.getFullYear(), currentStartDate.getMonth() + 1, 1).addDays(-1);
                channelPeriods = this.dayStatusService.getChannelPeriodsInRange(currentStartDate, enddate);
                var result = $.grep(channelPeriods, (element: IBooking, index) => {
                    return currentStartDate <= element.parsedStartdate && enddate >= element.parsedStartdate;
                });

                if (!!result[0]) {
                    periodDescription += channelPeriods[0].periodDescription;
                }
            }

            for (var i = currentStartDate.getDate(); i <= daysInMonth; i++) {
                var currentDate = new Date(currentStartDate.getFullYear(), currentStartDate.getMonth(), i);
                var nextDate = (new Date(currentDate.getTime())).addDays(1);

                // Sammensæt uger
                var currentWeek = currentDate.getWeek();
                var nextWeek = nextDate.getWeek();
                if (currentWeek !== nextWeek || i === enddateOfThisMonth.getDate()) {
                    var weekText = weekCount >= 3 ? this.localizedValues.uge + " " + currentWeek : "";
                    weeks += `<td data-date="${firstDateInWeek}" colspan="${weekCount}">${weekText}</td>`;
                    firstDateInWeek = nextDate.getDate();
                    weekCount = 0;
                }
                weekCount++;

                // Hent css-klasser for status på dag
                var currentDayStatus = "";
                var dayActive = "";
                if (this.dayStatusService !== undefined) {
                    currentDayStatus = this.dayStatusService.getStatusForDay(currentDate, !!this.domain);
                    var dayHasPrice = this.dayStatusService.dayHasPrice(currentDate);
                    if (!dayHasPrice) {
                        currentDayStatus = "noprice";
                    }
                    var disableSysMaxForDay = this.dayStatusService.sysMaxDateGælderIkkeForLodtrækninger && currentDayStatus.indexOf('drawperiod') > -1;
                    if (this.parameters.reservationRestrictions && (!dayHasPrice || (currentDate > self.dayStatusService.houseOpenUntill && !disableSysMaxForDay) || currentDayStatus.indexOf('restrictedPeriod') > -1 || currentDayStatus.indexOf('channelPeriod') > -1)) {
                        dayActive = "day-not-active";
                        
                    }

                    currentDayStatus = currentDayStatus.replace('restrictedPeriod', '');
                    currentDayStatus = currentDayStatus.replace('channelPeriod', '');
                }

                // Sammensæt dage med dato
                var currentDayOfWeek = currentDate.getDay();
                var currentDayOfMonth = currentDate.getDate();
                var dayClass = currentDayOfWeek === 0 || currentDayOfWeek === 6 ? "weekend" : "";
                days += `<td class="${dayClass} ${dayActive}" data-date="${currentDayOfMonth}"><div>${currentDayOfMonth}</div></td>`;

                if (self.parameters.showDaysBeforeTodayAsBooked && currentDate.getDateWithoutTime().getTime() < today.getTime()) {
                    currentDayStatus = "reservation";
                }

                // Sammensæt dage med farve
                colors += `<td data-date="${currentDayOfMonth}" class="${dayActive}"><div class="${currentDayStatus}"></div></td>`;
            }

            //insertPosition.before(`<div class="month new-month" data-month="${currentStartDate.getMonth() + 1}" data-year="${currentStartDate.getFullYear() }"><table>
            //    <tr class="weeks">${weeks}</tr>
            //    <tr class="days">${days}</tr>
            //    <tr class="colors">${colors}</tr>
            //</table></div>`);
            indhold += `<div class="month new-month" data-month="${currentStartDate.getMonth() + 1}" data-year="${currentStartDate.getFullYear()}">
                <table>
                    <tr class="weeks">${weeks}</tr>
                    <tr class="days">${days}</tr>
                    <tr class="colors">${colors}</tr>
                </table>
                <div class="periodDescription">
                    ${periodDescription}
                </div>
            </div>`;
            insertPosition.before(indhold);

            // Tilføj events på alle tabelceller i den nye måned
            var newMonth = this.pane.find(".new-month");
            var self = this;

            //newMonth.find(".days td:not(.day-not-active), .colors td:not(.day-not-active)").mouseenter(function () {
            //    self.showBubble(this);
            //}).mouseleave(function () {
            //    self.hideBubble(this);
            //});

            newMonth.find(".days td:not(.day-not-active), .colors td:not(.day-not-active)").on("click", function () {
                window.location.href = self.domain+`/book/${self.houseId}?date=${$(newMonth).attr("data-year") }-${+$(newMonth).attr("data-month")}-${$(this).attr("data-date") }`;
            });
            newMonth.removeClass("new-month");

            this.latestDateDrawn = enddateOfThisMonth;
            ++this.monthsDrawn;
            if (this.monthsDrawn < 3) {
                this.drawMonth(enddateOfThisMonth.addDays(1));
                //this.addMonth(false);
            }
        }


        private showBubble(target): void {
            
            //var self = this;

            ////TODO: Flyt den samme boble i stedet for at tegne en ny hver gang

            //$(".bubble").remove();
            //var bubble = $(`<div class="bubble">Klik for at booke</div>`);
            //bubble.css({'left': self.bubbleXpos });
            //$(target).append(bubble);

            //var offset = $(target).offset();
            //$(target).mousemove(function (e) {
            //    self.bubbleXpos = e.pageX - offset.left + 15;
            //    var top = -5;
            //    $(".bubble").css({'left': self.bubbleXpos});
            //});
        }
        private hideBubble(target): void {
            //$(".bubble").remove();
        }


    }


}
